export default __webpack_public_path__ + "static/media/three.adde670e.svg";